<template>
    <div id="app" clsas="col-sm-12">
        <div id="loading-spinner" v-if="isLoading">
            <clip-loader :loading="isLoading" :color="color" :size="size"></clip-loader>
        </div>
        <router-view />
    </div>
</template>

<script lang="ts">
    import ClipLoader from "vue-spinner/src/ClipLoader.vue"

    export default {
        name: "app",
        components: {
            clipLoader: ClipLoader
        },

        // eslint-disable-next-line
        data: function () {
            return {
                color: "#000000",
                size: "100px"
            }
        },

        computed: {
            isLoading: function (): boolean {
                // eslint-disable-next-line
                return (this as any).$store.getters.isLoading
            }
        }
    }
</script>

<style>
    #loading-spinner {
        z-index: 10000;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        background: #fff;
        opacity: 0.5;
    }

        #loading-spinner > div {
            margin: 0;
            top: 50%;
            -ms-transform: translateY(-50%);
            transform: translateY(-50%);
            position: relative;
        }
</style>
